<template>
  <v-card>
    <v-img
      class="white--text align-end"
      height="200px"
      src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"
    >
      <v-card-title>{{exam.name}}, Sections of this exam:</v-card-title>
    </v-img>
    <v-card-text class="text--primary">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">ID</th>
              <th class="text-left">Name</th>
              <th class="text-left">Type</th>
              <th class="text-left">Duration (min)</th>
              <th class="text-left"></th>
              <th class="text-left"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in sections" :key="item.id">
              <td>{{ item.id }}</td>
              <td>{{ item.title }}</td>
              <td>{{ item.type }}</td>
              <td>{{ item.duration }}</td>
              <td>
                <SectionModal
                  v-if="exam.status.localeCompare('setup') == 0"
                  :item="item"
                  @close="updateSection(item)"
                />
              </td>
              <td>
                <a :href="'/all/' + item.id">Manage Questions</a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-actions>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              dark
              v-on="on"
              v-if="exam.status.localeCompare('setup') == 0"
            >New Section</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">New Section</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="8">
                    <v-text-field label="Section Name*" v-model="new_section.title" required></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      label="Duration*"
                      hint="in minutes"
                      persistent-hint
                      type="number"
                      v-model="new_section.duration"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-select
                      :items="['Multiple Choices', 'Short Question']"
                      label="Question Type*"
                      v-model="new_section.type"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
              <v-btn color="blue darken-1" text @click="newSection()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-divider class="mx-4" vertical></v-divider>
      <v-btn
        color="error"
        v-if="exam.status.localeCompare('setup') == 0"
        @click="freeze()"
      >Freeze Question</v-btn>
      <v-btn
        color="error"
        v-if="exam.status.localeCompare('freezed') == 0"
        @click="released()"
      >Release Question</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import SectionModal from "@/views/SectionModal";

export default {
  name: "Exam",
  props: ["id"],

  components: {
    SectionModal
  },

  data: () => ({
    sections: [],
    // question_types: [
    //   { text: "Multple Choices", value: "MC" },
    //   { text: "Short Question", value: "SQ" }
    // ],
    exam: {status: "setup"},
    dialog: false,
    new_section: { name: "", duration: "", type: "" }
  }),

  methods: {
    async updateSection(section) {
      var response = await fetch(
        process.env.VUE_APP_API_BASE_URL + "/section/update/" + section.id,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
            // "Content-Type": "application/x-www-form-urlencoded"
          },
          body: JSON.stringify(section)
        }
      );

      if (response.ok) {
        var data = await response.json();
        console.log(data);

        this.dialog = false;

        // this.sections = data.sections.slice();
        // this.exam = data;
      } else {
        alert(response.status + ": " + response.statusText);
      }
      // }
    },
    async newSection() {
      var response = await fetch(
        process.env.VUE_APP_API_BASE_URL + "/exam/add/" + this.id + "/sections",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
            // "Content-Type": "application/x-www-form-urlencoded"
          },
          body: JSON.stringify(this.new_section)
        }
      );

      if (response.ok) {
        var data = await response.json();
        console.log(data);

        // this.dialog = false;

        this.sections = data.sections.slice();
        this.exam = data;
      } else {
        alert(response.status + ": " + response.statusText);
      }
      // }
    },
    async freeze() {
      var response = await fetch(
        process.env.VUE_APP_API_BASE_URL + "/exam/freeze/" + this.id,
        {
          method: "POST",
          credentials: "include",
          headers: {
            //   "Content-Type": "application/json"
            "Content-Type": "application/x-www-form-urlencoded"
          }
          // body: "question_type=" + option
        }
      );

      if (response.ok) {
        var data = await response.text();
        console.log(data);

        alert(data);

        this.exam.status = "freezed";

        // this.sections = data.sections.slice();
        // this.exam = data;
      } else {
        alert(response.status + ": " + response.statusText);
      }
    },
    async released() {
      var response = await fetch(
        process.env.VUE_APP_API_BASE_URL + "/exam/release/" + this.id,
        {
          method: "POST",
          credentials: "include",
          // headers: {
          //   //   "Content-Type": "application/json"
          //   "Content-Type": "application/x-www-form-urlencoded"
          // }
          // body: "question_type=" + option
        }
      );

      if (response.ok) {
        var data = await response.text();
        console.log(data);

        alert(data);

        // this.sections = data.sections.slice();
        // this.exam = data;
      } else {
        alert(response.status + ": " + response.statusText);
      }
    }
  },

  async mounted() {
    // alert("in exam.vue");

    if (this.id != "undefined") {
      var response = await fetch(
        process.env.VUE_APP_API_BASE_URL + "/exam/view/" + this.id,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
            // 'Content-Type': 'application/x-www-form-urlencoded',
          }
        }
      );

      if (response.ok) {
        var data = await response.json();
        console.log(data);

        this.sections = data.sections.slice();
        this.exam = data;
      } else {
        alert(response.status + ": " + response.statusText);
      }
    }
  }
};
</script>